import { Injectable } from '@angular/core';
import { DatabaseService } from './db-service';
import { DocumentService } from './document-service';
import { IdName, Church, DocumentReference } from '../models';
import { AngularFirestore  } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})

export class ChurchService {

    public collection: string = 'churches';
    private churchList: DocumentReference[];

    constructor(
        private afstore: AngularFirestore,
        private databaseService: DatabaseService,
        private documentService: DocumentService) {
    }

    public setChurchList = (churchList: DocumentReference[]): void => {
        this.churchList = churchList;
    } 

    public getChurchList = (): DocumentReference[] => {
        return this.churchList;
    }

    public getChurchDocument = async (id: string) => {
        return await this.documentService.getDocumentById(this.collection, id);
    }

    public getChurches() {
        return this.databaseService.getDocuments(this.collection, ref => ref
            .where('isActive', '==', true)
            .where('isDeleted', '==', false));
    }

    public getCountryChurchList(country: IdName) {
        return this.databaseService.getDocuments(this.collection, ref => ref
            .where('country', '==', country)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
    }

    public getCountryList() {
        const country: IdName[] = [
            { id: 'AU', name: 'Australia' },
            { id: 'NZ', name: 'New Zealand' },
            { id: 'FJ', name: 'Fiji' },
            { id: 'SI', name: 'Solomon Island' }
        ];

        return country;
    }

    public getAustraliaStateList() {
        const country: { id: string, name: string }[] = [
            { id: 'ACT', name: 'Australian Capital Territory' },
            { id: 'SA', name: 'South Australia' },
            { id: 'TAS', name: 'Tasmania' },
            { id: 'VIC', name: 'Victoria' },
            { id: 'WA', name: 'West Australia' }
        ];

        return country;
    }

    // CRUD functions
    // Create
    public async createChurch(church: Church) {
        this.afstore
                .collection(this.collection)
                .add(church);
    }
}
